// src/context/UserContext.js
import React, { createContext, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setProfilePictureUrl } from "../store/slices/userSlice";
import { fetchMyProfile } from "../services/personalPageService";

export const UserContext = createContext({
    profilePicture: "",
    setProfilePicture: () => { },
    fetchProfile: async () => { },
});

const selectProfilePictureUrl = (s) =>
    (s.user && s.user.profilePictureUrl) || "";

export const UserProvider = ({ children }) => {
    const dispatch = useDispatch();
    const profilePicture = useSelector(selectProfilePictureUrl);

    const setProfilePicture = useCallback(
        (url) => {
            dispatch(setProfilePictureUrl(url || ""));
        },
        [dispatch]
    );

    const fetchProfile = useCallback(async () => {
        try {
            const profile = await fetchMyProfile();
            const pic = profile?.profilePictureUrl || "";

            dispatch(setProfilePictureUrl(pic));
            return profile;
        } catch (err) {
            console.error("Не удалось получить профиль:", err);
            dispatch(setProfilePictureUrl(""));
            return null;
        }
    }, [dispatch]);

    return (
        <UserContext.Provider
            value={{ profilePicture, setProfilePicture, fetchProfile }}
        >
            {children}
        </UserContext.Provider>
    );
};